export default __webpack_public_path__ + "static/upiOptions2-4f35b224e3b0fb2dd9086c9ee2044224.webm";